import ConditionType from './ConditionType'

const CrossingDownCondition: ConditionType = {
  value: 'crossing down',
  label: 'Crossing Down',
  hasRHS: true,
}

export default CrossingDownCondition
